var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g, _path47, _g2, _path48, _path49, _g3, _path50, _path51, _g4, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSceneryLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 316,
    viewBox: "0 0 1440 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1420.43 297.114C821.998 276.799 192.916 287.138 -46.8211 294.847L-54.645 423.997L1422.31 409.098C1671.03 380.234 2018.85 317.428 1420.43 297.114Z",
    fill: "#FBCB84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9872 248.561C68.2355 248.347 67.6039 240.646 66.882 236.821L58.7614 235.22C57.8591 237.533 55.7839 242.798 54.7011 245.359C53.3477 248.561 60.927 248.828 64.9872 248.561Z",
    fill: "#492E0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9872 248.561C68.2355 248.347 67.6039 240.646 66.882 236.821L58.7614 235.22C57.8591 237.533 55.7839 242.798 54.7011 245.359C53.3477 248.561 60.927 248.828 64.9872 248.561Z",
    fill: "#492E0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9872 248.561C68.2355 248.347 67.6039 240.646 66.882 236.821L58.7614 235.22C57.8591 237.533 55.7839 242.798 54.7011 245.359C53.3477 248.561 60.927 248.828 64.9872 248.561Z",
    fill: "#492E0D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9872 248.561C68.2355 248.347 67.6039 240.646 66.882 236.821L58.7614 235.22C57.8591 237.533 55.7839 242.798 54.7011 245.359C53.3477 248.561 60.927 248.828 64.9872 248.561Z",
    fill: "#492E0D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5194 257.165C66.74 256.691 65.4913 249.065 64.4644 245.311L56.2413 244.368C55.5279 246.745 53.8826 252.16 53.0093 254.8C51.9176 258.101 59.4938 257.757 63.5194 257.165Z",
    fill: "#492E0D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5194 257.165C66.74 256.691 65.4913 249.065 64.4644 245.311L56.2413 244.368C55.5279 246.745 53.8826 252.16 53.0093 254.8C51.9176 258.101 59.4938 257.757 63.5194 257.165Z",
    fill: "#492E0D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5194 257.165C66.74 256.691 65.4913 249.065 64.4644 245.311L56.2413 244.368C55.5279 246.745 53.8826 252.16 53.0093 254.8C51.9176 258.101 59.4938 257.757 63.5194 257.165Z",
    fill: "#492E0D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5194 257.165C66.74 256.691 65.4913 249.065 64.4644 245.311L56.2413 244.368C55.5279 246.745 53.8826 252.16 53.0093 254.8C51.9176 258.101 59.4938 257.757 63.5194 257.165Z",
    fill: "#492E0D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2038 267.252C65.8151 266.721 64.4149 258.169 63.2634 253.96L54.0427 252.902C53.2427 255.568 51.3978 261.64 50.4185 264.601C49.1944 268.301 57.6897 267.916 62.2038 267.252Z",
    fill: "#492E0D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2038 267.252C65.8151 266.721 64.4149 258.169 63.2634 253.96L54.0427 252.902C53.2427 255.568 51.3978 261.64 50.4185 264.601C49.1944 268.301 57.6897 267.916 62.2038 267.252Z",
    fill: "#492E0D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2038 267.252C65.8151 266.721 64.4149 258.169 63.2634 253.96L54.0427 252.902C53.2427 255.568 51.3978 261.64 50.4185 264.601C49.1944 268.301 57.6897 267.916 62.2038 267.252Z",
    fill: "#492E0D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2038 267.252C65.8151 266.721 64.4149 258.169 63.2634 253.96L54.0427 252.902C53.2427 255.568 51.3978 261.64 50.4185 264.601C49.1944 268.301 57.6897 267.916 62.2038 267.252Z",
    fill: "#492E0D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0298 278.174C64.8754 277.608 63.3843 268.502 62.1581 264.019L52.3391 262.893C51.4872 265.732 49.5226 272.198 48.4797 275.35C47.1762 279.291 56.2228 278.881 61.0298 278.174Z",
    fill: "#492E0D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0298 278.174C64.8754 277.608 63.3843 268.502 62.1581 264.019L52.3391 262.893C51.4872 265.732 49.5226 272.198 48.4797 275.35C47.1762 279.291 56.2228 278.881 61.0298 278.174Z",
    fill: "#492E0D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0298 278.174C64.8754 277.608 63.3843 268.502 62.1581 264.019L52.3391 262.893C51.4872 265.732 49.5226 272.198 48.4797 275.35C47.1762 279.291 56.2228 278.881 61.0298 278.174Z",
    fill: "#492E0D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0298 278.174C64.8754 277.608 63.3843 268.502 62.1581 264.019L52.3391 262.893C51.4872 265.732 49.5226 272.198 48.4797 275.35C47.1762 279.291 56.2228 278.881 61.0298 278.174Z",
    fill: "#492E0D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0505 291.738C64.5238 291.08 62.7894 280.487 61.363 275.273L49.9413 273.963C48.9503 277.266 46.665 284.787 45.452 288.454C43.9357 293.038 54.4589 292.561 60.0505 291.738Z",
    fill: "#492E0D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0505 291.738C64.5238 291.08 62.7894 280.487 61.363 275.273L49.9413 273.963C48.9503 277.266 46.665 284.787 45.452 288.454C43.9357 293.038 54.4589 292.561 60.0505 291.738Z",
    fill: "#492E0D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0505 291.738C64.5238 291.08 62.7894 280.487 61.363 275.273L49.9413 273.963C48.9503 277.266 46.665 284.787 45.452 288.454C43.9357 293.038 54.4589 292.561 60.0505 291.738Z",
    fill: "#492E0D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0505 291.738C64.5238 291.08 62.7894 280.487 61.363 275.273L49.9413 273.963C48.9503 277.266 46.665 284.787 45.452 288.454C43.9357 293.038 54.4589 292.561 60.0505 291.738Z",
    fill: "#492E0D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8113 305.237C64.5552 304.114 61.7068 292.897 59.6896 287.428L47.2986 287.084C46.5413 290.723 44.786 299.015 43.8241 303.067C42.6217 308.132 53.8813 306.641 59.8113 305.237Z",
    fill: "#492E0D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8113 305.237C64.5552 304.114 61.7068 292.897 59.6896 287.428L47.2986 287.084C46.5413 290.723 44.786 299.015 43.8241 303.067C42.6217 308.132 53.8813 306.641 59.8113 305.237Z",
    fill: "#492E0D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8113 305.237C64.5552 304.114 61.7068 292.897 59.6896 287.428L47.2986 287.084C46.5413 290.723 44.786 299.015 43.8241 303.067C42.6217 308.132 53.8813 306.641 59.8113 305.237Z",
    fill: "#492E0D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8113 305.237C64.5552 304.114 61.7068 292.897 59.6896 287.428L47.2986 287.084C46.5413 290.723 44.786 299.015 43.8241 303.067C42.6217 308.132 53.8813 306.641 59.8113 305.237Z",
    fill: "#492E0D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8549 321.351C66.1417 319.739 62.1113 307.252 59.4353 301.21L45.3907 301.712C44.7957 305.885 43.4066 315.393 42.6099 320.047C41.614 325.864 54.2465 323.367 60.8549 321.351Z",
    fill: "#492E0D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8549 321.351C66.1417 319.739 62.1113 307.252 59.4353 301.21L45.3907 301.712C44.7957 305.885 43.4066 315.393 42.6099 320.047C41.614 325.864 54.2465 323.367 60.8549 321.351Z",
    fill: "#492E0D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8549 321.351C66.1417 319.739 62.1113 307.252 59.4353 301.21L45.3907 301.712C44.7957 305.885 43.4066 315.393 42.6099 320.047C41.614 325.864 54.2465 323.367 60.8549 321.351Z",
    fill: "#492E0D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8549 321.351C66.1417 319.739 62.1113 307.252 59.4353 301.21L45.3907 301.712C44.7957 305.885 43.4066 315.393 42.6099 320.047C41.614 325.864 54.2465 323.367 60.8549 321.351Z",
    fill: "#492E0D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1727 337.758C66.6893 336.076 62.4837 323.046 59.6914 316.742L45.0362 317.266C44.4154 321.619 42.9659 331.541 42.1346 336.397C41.0954 342.468 54.277 339.861 61.1727 337.758Z",
    fill: "#492E0D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1727 337.758C66.6893 336.076 62.4837 323.046 59.6914 316.742L45.0362 317.266C44.4154 321.619 42.9659 331.541 42.1346 336.397C41.0954 342.468 54.277 339.861 61.1727 337.758Z",
    fill: "#492E0D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1727 337.758C66.6893 336.076 62.4837 323.046 59.6914 316.742L45.0362 317.266C44.4154 321.619 42.9659 331.541 42.1346 336.397C41.0954 342.468 54.277 339.861 61.1727 337.758Z",
    fill: "#492E0D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1727 337.758C66.6893 336.076 62.4837 323.046 59.6914 316.742L45.0362 317.266C44.4154 321.619 42.9659 331.541 42.1346 336.397C41.0954 342.468 54.277 339.861 61.1727 337.758Z",
    fill: "#492E0D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2325 356.557C68.0716 354.776 63.6202 340.985 60.6646 334.312L45.1528 334.866C44.4957 339.475 42.9615 349.976 42.0815 355.116C40.9816 361.541 54.9337 358.783 62.2325 356.557Z",
    fill: "#492E0D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2325 356.557C68.0716 354.776 63.6202 340.985 60.6646 334.312L45.1528 334.866C44.4957 339.475 42.9615 349.976 42.0815 355.116C40.9816 361.541 54.9337 358.783 62.2325 356.557Z",
    fill: "#492E0D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2325 356.557C68.0716 354.776 63.6202 340.985 60.6646 334.312L45.1528 334.866C44.4957 339.475 42.9615 349.976 42.0815 355.116C40.9816 361.541 54.9337 358.783 62.2325 356.557Z",
    fill: "#492E0D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2325 356.557C68.0716 354.776 63.6202 340.985 60.6646 334.312L45.1528 334.866C44.4957 339.475 42.9615 349.976 42.0815 355.116C40.9816 361.541 54.9337 358.783 62.2325 356.557Z",
    fill: "#492E0D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7522 376.667C68.51 375.372 65.1764 359.381 62.6648 351.547L45.2135 350.307C43.9239 355.393 40.9441 366.978 39.341 372.633C37.3371 379.702 53.3049 378.285 61.7522 376.667Z",
    fill: "#492E0D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7522 376.667C68.51 375.372 65.1764 359.381 62.6648 351.547L45.2135 350.307C43.9239 355.393 40.9441 366.978 39.341 372.633C37.3371 379.702 53.3049 378.285 61.7522 376.667Z",
    fill: "#492E0D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7522 376.667C68.51 375.372 65.1764 359.381 62.6648 351.547L45.2135 350.307C43.9239 355.393 40.9441 366.978 39.341 372.633C37.3371 379.702 53.3049 378.285 61.7522 376.667Z",
    fill: "#492E0D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7522 376.667C68.51 375.372 65.1764 359.381 62.6648 351.547L45.2135 350.307C43.9239 355.393 40.9441 366.978 39.341 372.633C37.3371 379.702 53.3049 378.285 61.7522 376.667Z",
    fill: "#492E0D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9243 249.556C73.3279 249.556 68.8715 241.935 66.7179 238.125C55.8668 235.806 42.1167 226.147 73.9243 206.069C105.732 185.99 133.895 205.986 144 218.494C134.259 209.349 116.914 208.885 109.459 209.796C109.658 210.194 109.708 210.956 109.708 211.287C99.569 209.896 94.3837 212.198 93.0584 213.524C91.468 216.705 93.0584 217.5 94.0524 217.5C102.601 217.102 112.358 223.298 116.169 226.446C115.572 226.247 115.092 226.86 114.926 227.191C127.649 235.938 132.818 245.745 133.812 249.556H132.569C136.347 259.496 134.143 266.785 132.569 269.187C131.973 261.633 125.694 252.952 122.629 249.556C123.027 250.351 122.464 252.041 122.132 252.786C122.132 251.196 111.696 241.687 106.477 237.131C106.875 238.522 106.643 240.03 106.477 240.61C94.5494 231.664 89.5795 230.587 88.5855 231.167C89.1819 231.366 89.6623 233.072 89.828 233.9C88.4364 233.702 87.9229 234.48 87.84 234.894C96.5871 241.057 99.4365 255.354 99.7679 261.732H98.7738C100.563 278.033 93.8868 291.055 90.325 295.528C93.5057 283.997 92.313 273.163 91.319 269.187C90.325 268.988 89.4139 271.258 89.0826 272.417C89.2814 267.249 85.0238 258.17 82.8701 254.277C83.0358 255.768 83.1186 258.7 82.1246 258.502C81.1307 258.303 76.7406 249.142 74.6698 244.586C74.6698 246.242 74.5207 249.556 73.9243 249.556Z",
    fill: "#214325"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8017 243.154C51.3652 243.249 67.6047 232.913 70.1891 229.996C80.7762 229.741 95.1609 223.668 68.0031 201.424C40.8453 179.18 11.352 191.802 9.02412e-05 200.893C10.5227 194.621 26.9781 196.986 33.8904 198.953C33.6452 199.262 33.4884 199.906 33.4406 200.189C43.2208 200.614 47.788 203.409 48.8491 204.754C49.8931 207.729 48.2757 208.156 47.3365 207.998C39.3171 206.296 29.204 210.042 25.15 212.128C25.7421 212.053 26.1077 212.654 26.2164 212.964C12.9337 218.421 6.63563 225.988 5.14697 229.09L6.32085 229.288C1.31855 237.19 2.34917 243.777 3.48976 246.083C5.14269 239.715 12.3271 233.288 15.7126 230.871C15.2223 231.488 15.5108 233.023 15.7163 233.714C15.9457 232.353 27.1782 225.88 32.7658 222.814C32.1895 223.941 32.1912 225.267 32.2641 225.79C44.8242 220.036 38.7454 224.433 39.6009 225.087C39.0087 225.162 38.3087 226.546 38.0328 227.228C39.3763 227.28 39.7492 228.027 39.7677 228.395C30.6143 232.274 25.8603 244.052 24.6274 249.455L25.5666 249.614C21.5252 263.275 25.9554 275.478 28.6757 279.872C27.3332 269.501 30.0227 260.422 31.5352 257.179C32.503 257.167 33.0366 259.254 33.1824 260.299C33.74 255.845 39.072 248.757 41.6683 245.769C41.2967 247.018 40.7956 249.514 41.7634 249.502C42.7313 249.49 48.2004 242.352 50.814 238.784C50.5751 240.201 50.2382 243.059 50.8017 243.154Z",
    fill: "#214325"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1406.35 423.94L1101.78 155.536L1092.09 173.702L1000.83 426.276L1406.35 423.94Z",
    fill: "url(#paint0_linear_6_194)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M998.317 425.318L882.62 355.259L1101.78 155.536L998.317 425.318Z",
    fill: "url(#paint1_linear_6_194)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_194",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1000,
    y: 155,
    width: 407,
    height: 272
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1406.35 423.94L1101.78 155.536L1092.09 173.702L1000.83 426.276L1406.35 423.94Z",
    fill: "url(#paint2_linear_6_194)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_194)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1235.9 428.314L808.889 15.9536L793.847 43.211L599.992 439.035L1235.9 428.314Z",
    fill: "black",
    fillOpacity: 0.24
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6_194",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 882,
    y: 155,
    width: 220,
    height: 271
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M998.317 425.318L882.62 355.259L1101.78 155.536L998.317 425.318Z",
    fill: "url(#paint3_linear_6_194)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6_194)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_6_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1235.9 428.314L808.889 15.9536L793.847 43.211L599.992 439.035L1235.9 428.314Z",
    fill: "black",
    fillOpacity: 0.24
  })))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.91 429.157L758.897 16.7964L743.854 44.0539L549.999 439.878L1185.91 429.157Z",
    fill: "url(#paint4_linear_6_194)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6_194",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 549,
    y: 16,
    width: 637,
    height: 424
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.91 429.157L758.897 16.7964L743.854 44.0539L549.999 439.878L1185.91 429.157Z",
    fill: "url(#paint5_linear_6_194)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6_194)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_6_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M728.406 432.87L366.065 89.4289L349.413 110.213L153.988 442.554L728.406 432.87Z",
    fill: "black",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.495 442.877L67.5617 418.008L366.065 89.4289L164.495 442.877Z",
    fill: "black",
    fillOpacity: 0.36
  })))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M575.779 396.937L449.903 346.052L758.897 16.7964L575.779 396.937Z",
    fill: "url(#paint6_linear_6_194)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6_194",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 449,
    y: 16,
    width: 310,
    height: 381
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M575.779 396.937L449.903 346.052L758.897 16.7964L575.779 396.937Z",
    fill: "url(#paint7_linear_6_194)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6_194)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_6_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M728.406 432.87L366.065 89.4289L349.413 110.213L153.988 442.554L728.406 432.87Z",
    fill: "black",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.495 442.877L67.5618 418.008L366.065 89.4289L164.495 442.877Z",
    fill: "black",
    fillOpacity: 0.36
  })))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M699.579 443.357L337.238 99.9164L320.586 120.7L125.16 453.042L699.579 443.357Z",
    fill: "url(#paint8_linear_6_194)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M135.667 453.365L38.7344 428.495L337.238 99.9164L135.667 453.365Z",
    fill: "url(#paint9_linear_6_194)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M167.861 162.854C173.252 162.5 172.203 149.717 171.005 143.37L157.527 140.713C156.03 144.551 152.586 153.289 150.789 157.54C148.542 162.854 161.122 163.297 167.861 162.854Z",
    fill: "#492E0D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M167.861 162.854C173.252 162.5 172.203 149.717 171.005 143.37L157.527 140.713C156.03 144.551 152.586 153.289 150.789 157.54C148.542 162.854 161.122 163.297 167.861 162.854Z",
    fill: "#492E0D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M167.861 162.854C173.252 162.5 172.203 149.717 171.005 143.37L157.527 140.713C156.03 144.551 152.586 153.289 150.789 157.54C148.542 162.854 161.122 163.297 167.861 162.854Z",
    fill: "#492E0D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M167.861 162.854C173.252 162.5 172.203 149.717 171.005 143.37L157.527 140.713C156.03 144.551 152.586 153.289 150.789 157.54C148.542 162.854 161.122 163.297 167.861 162.854Z",
    fill: "#492E0D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M165.424 177.135C170.77 176.348 168.697 163.691 166.993 157.46L153.345 155.895C152.161 159.841 149.43 168.828 147.98 173.21C146.169 178.688 158.743 178.118 165.424 177.135Z",
    fill: "#492E0D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M165.424 177.135C170.77 176.348 168.697 163.691 166.993 157.46L153.345 155.895C152.161 159.841 149.43 168.828 147.98 173.21C146.169 178.688 158.743 178.118 165.424 177.135Z",
    fill: "#492E0D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M165.424 177.135C170.77 176.348 168.697 163.691 166.993 157.46L153.345 155.895C152.161 159.841 149.43 168.828 147.98 173.21C146.169 178.688 158.743 178.118 165.424 177.135Z",
    fill: "#492E0D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M165.424 177.135C170.77 176.348 168.697 163.691 166.993 157.46L153.345 155.895C152.161 159.841 149.43 168.828 147.98 173.21C146.169 178.688 158.743 178.118 165.424 177.135Z",
    fill: "#492E0D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M163.241 193.876C169.235 192.994 166.911 178.801 164.999 171.815L149.696 170.06C148.368 174.485 145.306 184.562 143.681 189.476C141.649 195.618 155.749 194.979 163.241 193.876Z",
    fill: "#492E0D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M163.241 193.876C169.235 192.994 166.911 178.801 164.999 171.815L149.696 170.06C148.368 174.485 145.306 184.562 143.681 189.476C141.649 195.618 155.749 194.979 163.241 193.876Z",
    fill: "#492E0D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M163.241 193.876C169.235 192.994 166.911 178.801 164.999 171.815L149.696 170.06C148.368 174.485 145.306 184.562 143.681 189.476C141.649 195.618 155.749 194.979 163.241 193.876Z",
    fill: "#492E0D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M163.241 193.876C169.235 192.994 166.911 178.801 164.999 171.815L149.696 170.06C148.368 174.485 145.306 184.562 143.681 189.476C141.649 195.618 155.749 194.979 163.241 193.876Z",
    fill: "#492E0D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M161.292 212.004C167.675 211.064 165.2 195.95 163.165 188.511L146.868 186.642C145.454 191.354 142.194 202.085 140.463 207.318C138.299 213.858 153.314 213.178 161.292 212.004Z",
    fill: "#492E0D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M161.292 212.004C167.675 211.064 165.2 195.95 163.165 188.511L146.868 186.642C145.454 191.354 142.194 202.085 140.463 207.318C138.299 213.858 153.314 213.178 161.292 212.004Z",
    fill: "#492E0D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M161.292 212.004C167.675 211.064 165.2 195.95 163.165 188.511L146.868 186.642C145.454 191.354 142.194 202.085 140.463 207.318C138.299 213.858 153.314 213.178 161.292 212.004Z",
    fill: "#492E0D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M161.292 212.004C167.675 211.064 165.2 195.95 163.165 188.511L146.868 186.642C145.454 191.354 142.194 202.085 140.463 207.318C138.299 213.858 153.314 213.178 161.292 212.004Z",
    fill: "#492E0D"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M159.667 234.517C167.091 233.424 164.213 215.843 161.845 207.189L142.889 205.015C141.244 210.496 137.451 222.979 135.437 229.066C132.921 236.674 150.386 235.882 159.667 234.517Z",
    fill: "#492E0D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M159.667 234.517C167.091 233.424 164.213 215.843 161.845 207.189L142.889 205.015C141.244 210.496 137.451 222.979 135.437 229.066C132.921 236.674 150.386 235.882 159.667 234.517Z",
    fill: "#492E0D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M159.667 234.517C167.091 233.424 164.213 215.843 161.845 207.189L142.889 205.015C141.244 210.496 137.451 222.979 135.437 229.066C132.921 236.674 150.386 235.882 159.667 234.517Z",
    fill: "#492E0D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M159.667 234.517C167.091 233.424 164.213 215.843 161.845 207.189L142.889 205.015C141.244 210.496 137.451 222.979 135.437 229.066C132.921 236.674 150.386 235.882 159.667 234.517Z",
    fill: "#492E0D"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M159.27 256.921C167.144 255.057 162.416 236.439 159.068 227.364L138.502 226.792C137.245 232.832 134.332 246.594 132.736 253.32C130.74 261.726 149.428 259.251 159.27 256.921Z",
    fill: "#492E0D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M159.27 256.921C167.144 255.057 162.416 236.439 159.068 227.364L138.502 226.792C137.245 232.832 134.332 246.594 132.736 253.32C130.74 261.726 149.428 259.251 159.27 256.921Z",
    fill: "#492E0D"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M159.27 256.921C167.144 255.057 162.416 236.439 159.068 227.364L138.502 226.792C137.245 232.832 134.332 246.594 132.736 253.32C130.74 261.726 149.428 259.251 159.27 256.921Z",
    fill: "#492E0D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M159.27 256.921C167.144 255.057 162.416 236.439 159.068 227.364L138.502 226.792C137.245 232.832 134.332 246.594 132.736 253.32C130.74 261.726 149.428 259.251 159.27 256.921Z",
    fill: "#492E0D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M161.002 283.666C169.777 280.99 163.087 260.265 158.646 250.237L135.336 251.071C134.348 257.996 132.043 273.777 130.72 281.501C129.068 291.156 150.034 287.011 161.002 283.666Z",
    fill: "#492E0D"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M161.002 283.666C169.777 280.99 163.087 260.265 158.646 250.237L135.336 251.071C134.348 257.996 132.043 273.777 130.72 281.501C129.068 291.156 150.034 287.011 161.002 283.666Z",
    fill: "#492E0D"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M161.002 283.666C169.777 280.99 163.087 260.265 158.646 250.237L135.336 251.071C134.348 257.996 132.043 273.777 130.72 281.501C129.068 291.156 150.034 287.011 161.002 283.666Z",
    fill: "#492E0D"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M161.002 283.666C169.777 280.99 163.087 260.265 158.646 250.237L135.336 251.071C134.348 257.996 132.043 273.777 130.72 281.501C129.068 291.156 150.034 287.011 161.002 283.666Z",
    fill: "#492E0D"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M161.53 310.897C170.685 308.105 163.705 286.479 159.071 276.016L134.747 276.885C133.717 284.111 131.311 300.578 129.932 308.638C128.207 318.713 150.085 314.388 161.53 310.897Z",
    fill: "#492E0D"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M161.53 310.897C170.685 308.105 163.705 286.479 159.071 276.016L134.747 276.885C133.717 284.111 131.311 300.578 129.932 308.638C128.207 318.713 150.085 314.388 161.53 310.897Z",
    fill: "#492E0D"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M161.53 310.897C170.685 308.105 163.705 286.479 159.071 276.016L134.747 276.885C133.717 284.111 131.311 300.578 129.932 308.638C128.207 318.713 150.085 314.388 161.53 310.897Z",
    fill: "#492E0D"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M161.53 310.897C170.685 308.105 163.705 286.479 159.071 276.016L134.747 276.885C133.717 284.111 131.311 300.578 129.932 308.638C128.207 318.713 150.085 314.388 161.53 310.897Z",
    fill: "#492E0D"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M163.289 342.098C172.98 339.142 165.592 316.252 160.686 305.177L134.941 306.097C133.85 313.746 131.304 331.175 129.843 339.706C128.018 350.37 151.175 345.792 163.289 342.098Z",
    fill: "#492E0D"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M163.289 342.098C172.98 339.142 165.592 316.252 160.686 305.177L134.941 306.097C133.85 313.746 131.304 331.175 129.843 339.706C128.018 350.37 151.175 345.792 163.289 342.098Z",
    fill: "#492E0D"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M163.289 342.098C172.98 339.142 165.592 316.252 160.686 305.177L134.941 306.097C133.85 313.746 131.304 331.175 129.843 339.706C128.018 350.37 151.175 345.792 163.289 342.098Z",
    fill: "#492E0D"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M163.289 342.098C172.98 339.142 165.592 316.252 160.686 305.177L134.941 306.097C133.85 313.746 131.304 331.175 129.843 339.706C128.018 350.37 151.175 345.792 163.289 342.098Z",
    fill: "#492E0D"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M162.491 375.474C173.707 373.325 168.174 346.785 164.006 333.783L135.042 331.725C132.901 340.166 127.956 359.394 125.295 368.78C121.969 380.513 148.471 378.161 162.491 375.474Z",
    fill: "#492E0D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M162.491 375.474C173.707 373.325 168.174 346.785 164.006 333.783L135.042 331.725C132.901 340.166 127.956 359.394 125.295 368.78C121.969 380.513 148.471 378.161 162.491 375.474Z",
    fill: "#492E0D"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M162.491 375.474C173.707 373.325 168.174 346.785 164.006 333.783L135.042 331.725C132.901 340.166 127.956 359.394 125.295 368.78C121.969 380.513 148.471 378.161 162.491 375.474Z",
    fill: "#492E0D"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M162.491 375.474C173.707 373.325 168.174 346.785 164.006 333.783L135.042 331.725C132.901 340.166 127.956 359.394 125.295 368.78C121.969 380.513 148.471 378.161 162.491 375.474Z",
    fill: "#492E0D"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M182.694 164.505C181.704 164.505 174.307 151.858 170.733 145.534C152.723 141.684 129.902 125.654 182.694 92.3295C235.485 59.0048 282.228 92.192 299 112.951C282.833 97.7736 254.045 97.0037 241.672 98.516C242.002 99.1759 242.084 100.441 242.084 100.991C225.257 98.6809 216.651 102.503 214.451 104.702C211.811 109.982 214.451 111.301 216.101 111.301C230.288 110.642 246.483 120.925 252.807 126.149C251.817 125.819 251.02 126.836 250.745 127.386C271.862 141.904 280.44 158.181 282.09 164.505H280.028C286.297 181.003 282.64 193.101 280.028 197.088C279.038 184.55 268.617 170.142 263.531 164.505C264.19 165.825 263.256 168.63 262.706 169.867C262.706 167.228 245.384 151.445 236.722 143.884C237.382 146.193 236.997 148.695 236.722 149.658C216.926 134.81 208.677 133.023 207.027 133.985C208.017 134.315 208.814 137.147 209.089 138.522C206.78 138.192 205.927 139.484 205.79 140.172C220.308 150.4 225.037 174.129 225.587 184.715H223.937C226.906 211.771 215.826 233.382 209.914 240.806C215.193 221.669 213.214 203.687 211.564 197.088C209.914 196.758 208.402 200.525 207.852 202.449C208.182 193.871 201.116 178.803 197.541 172.342C197.816 174.816 197.954 179.683 196.304 179.353C194.654 179.023 187.368 163.818 183.931 156.257C183.931 159.006 183.683 164.505 182.694 164.505Z",
    fill: "#214325"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M144.316 153.881C145.252 154.039 172.205 136.884 176.494 132.043C194.066 131.618 217.94 121.539 172.866 84.6203C127.792 47.702 78.841 68.6497 60 83.7384C77.4646 73.3286 104.776 77.255 116.248 80.5195C115.842 81.0315 115.581 82.1004 115.502 82.5709C131.734 83.275 139.315 87.9155 141.076 90.1477C142.808 95.0845 140.124 95.7932 138.565 95.5305C125.255 92.7062 108.47 98.9245 101.742 102.387C102.725 102.262 103.331 103.259 103.512 103.774C81.4661 112.831 71.0131 125.39 68.5424 130.538L70.4907 130.866C62.1882 143.981 63.8988 154.914 65.7918 158.741C68.5353 148.172 80.4593 137.506 86.0784 133.494C85.2646 134.518 85.7434 137.066 86.0846 138.212C86.4652 135.954 105.108 125.21 114.382 120.121C113.425 121.992 113.428 124.194 113.549 125.061C134.396 115.511 124.306 122.809 125.726 123.895C124.744 124.019 123.582 126.315 123.124 127.448C125.353 127.533 125.972 128.775 126.003 129.385C110.811 135.823 102.921 155.37 100.874 164.339L102.433 164.602C95.7257 187.276 103.079 207.53 107.594 214.823C105.365 197.61 109.829 182.541 112.339 177.158C113.946 177.138 114.831 180.602 115.073 182.336C115.999 174.944 124.848 163.179 129.158 158.22C128.541 160.294 127.709 164.435 129.316 164.416C130.922 164.396 139.999 152.549 144.337 146.627C143.94 148.979 143.381 153.724 144.316 153.881Z",
    fill: "#214325"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1366.37 148.151C1359.66 147.71 1360.96 131.785 1362.45 123.877L1379.24 120.567C1381.11 125.349 1385.4 136.235 1387.64 141.531C1390.44 148.151 1374.77 148.703 1366.37 148.151Z",
    fill: "#492E0D"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1366.37 148.151C1359.66 147.71 1360.96 131.785 1362.45 123.877L1379.24 120.567C1381.11 125.349 1385.4 136.235 1387.64 141.531C1390.44 148.151 1374.77 148.703 1366.37 148.151Z",
    fill: "#492E0D"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1366.37 148.151C1359.66 147.71 1360.96 131.785 1362.45 123.877L1379.24 120.567C1381.11 125.349 1385.4 136.235 1387.64 141.531C1390.44 148.151 1374.77 148.703 1366.37 148.151Z",
    fill: "#492E0D"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1366.37 148.151C1359.66 147.71 1360.96 131.785 1362.45 123.877L1379.24 120.567C1381.11 125.349 1385.4 136.235 1387.64 141.531C1390.44 148.151 1374.77 148.703 1366.37 148.151Z",
    fill: "#492E0D"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1369.41 165.941C1362.75 164.962 1365.33 149.193 1367.45 141.431L1384.46 139.482C1385.93 144.397 1389.33 155.593 1391.14 161.052C1393.4 167.876 1377.73 167.166 1369.41 165.941Z",
    fill: "#492E0D"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1369.41 165.941C1362.75 164.962 1365.33 149.193 1367.45 141.431L1384.46 139.482C1385.93 144.397 1389.33 155.593 1391.14 161.052C1393.4 167.876 1377.73 167.166 1369.41 165.941Z",
    fill: "#492E0D"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1369.41 165.941C1362.75 164.962 1365.33 149.193 1367.45 141.431L1384.46 139.482C1385.93 144.397 1389.33 155.593 1391.14 161.052C1393.4 167.876 1377.73 167.166 1369.41 165.941Z",
    fill: "#492E0D"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1369.41 165.941C1362.75 164.962 1365.33 149.193 1367.45 141.431L1384.46 139.482C1385.93 144.397 1389.33 155.593 1391.14 161.052C1393.4 167.876 1377.73 167.166 1369.41 165.941Z",
    fill: "#492E0D"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1372.13 186.798C1364.66 185.699 1367.55 168.017 1369.94 159.314L1389 157.128C1390.66 162.64 1394.47 175.194 1396.49 181.316C1399.03 188.967 1381.46 188.171 1372.13 186.798Z",
    fill: "#492E0D"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M1372.13 186.798C1364.66 185.699 1367.55 168.017 1369.94 159.314L1389 157.128C1390.66 162.64 1394.47 175.194 1396.49 181.316C1399.03 188.967 1381.46 188.171 1372.13 186.798Z",
    fill: "#492E0D"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1372.13 186.798C1364.66 185.699 1367.55 168.017 1369.94 159.314L1389 157.128C1390.66 162.64 1394.47 175.194 1396.49 181.316C1399.03 188.967 1381.46 188.171 1372.13 186.798Z",
    fill: "#492E0D"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1372.13 186.798C1364.66 185.699 1367.55 168.017 1369.94 159.314L1389 157.128C1390.66 162.64 1394.47 175.194 1396.49 181.316C1399.03 188.967 1381.46 188.171 1372.13 186.798Z",
    fill: "#492E0D"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.55 209.38C1366.6 208.21 1369.69 189.382 1372.22 180.113L1392.52 177.785C1394.29 183.655 1398.35 197.024 1400.5 203.543C1403.2 211.691 1384.49 210.843 1374.55 209.38Z",
    fill: "#492E0D"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.55 209.38C1366.6 208.21 1369.69 189.382 1372.22 180.113L1392.52 177.785C1394.29 183.655 1398.35 197.024 1400.5 203.543C1403.2 211.691 1384.49 210.843 1374.55 209.38Z",
    fill: "#492E0D"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.55 209.38C1366.6 208.21 1369.69 189.382 1372.22 180.113L1392.52 177.785C1394.29 183.655 1398.35 197.024 1400.5 203.543C1403.2 211.691 1384.49 210.843 1374.55 209.38Z",
    fill: "#492E0D"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.55 209.38C1366.6 208.21 1369.69 189.382 1372.22 180.113L1392.52 177.785C1394.29 183.655 1398.35 197.024 1400.5 203.543C1403.2 211.691 1384.49 210.843 1374.55 209.38Z",
    fill: "#492E0D"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.58 237.427C1367.33 236.066 1370.92 214.164 1373.87 203.383L1397.48 200.675C1399.53 207.503 1404.26 223.054 1406.76 230.636C1409.9 240.114 1388.14 239.128 1376.58 237.427Z",
    fill: "#492E0D"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.58 237.427C1367.33 236.066 1370.92 214.164 1373.87 203.383L1397.48 200.675C1399.53 207.503 1404.26 223.054 1406.76 230.636C1409.9 240.114 1388.14 239.128 1376.58 237.427Z",
    fill: "#492E0D"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.58 237.427C1367.33 236.066 1370.92 214.164 1373.87 203.383L1397.48 200.675C1399.53 207.503 1404.26 223.054 1406.76 230.636C1409.9 240.114 1388.14 239.128 1376.58 237.427Z",
    fill: "#492E0D"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.58 237.427C1367.33 236.066 1370.92 214.164 1373.87 203.383L1397.48 200.675C1399.53 207.503 1404.26 223.054 1406.76 230.636C1409.9 240.114 1388.14 239.128 1376.58 237.427Z",
    fill: "#492E0D"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1377.07 265.338C1367.26 263.016 1373.15 239.822 1377.33 228.516L1402.95 227.804C1404.51 235.329 1408.14 252.473 1410.13 260.851C1412.62 271.324 1389.33 268.241 1377.07 265.338Z",
    fill: "#492E0D"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1377.07 265.338C1367.26 263.016 1373.15 239.822 1377.33 228.516L1402.95 227.804C1404.51 235.329 1408.14 252.473 1410.13 260.851C1412.62 271.324 1389.33 268.241 1377.07 265.338Z",
    fill: "#492E0D"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1377.07 265.338C1367.26 263.016 1373.15 239.822 1377.33 228.516L1402.95 227.804C1404.51 235.329 1408.14 252.473 1410.13 260.851C1412.62 271.324 1389.33 268.241 1377.07 265.338Z",
    fill: "#492E0D"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1377.07 265.338C1367.26 263.016 1373.15 239.822 1377.33 228.516L1402.95 227.804C1404.51 235.329 1408.14 252.473 1410.13 260.851C1412.62 271.324 1389.33 268.241 1377.07 265.338Z",
    fill: "#492E0D"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.92 298.657C1363.98 295.323 1372.32 269.504 1377.85 257.012L1406.89 258.05C1408.12 266.677 1410.99 286.337 1412.64 295.96C1414.7 307.988 1388.58 302.824 1374.92 298.657Z",
    fill: "#492E0D"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.92 298.657C1363.98 295.323 1372.32 269.504 1377.85 257.012L1406.89 258.05C1408.12 266.677 1410.99 286.337 1412.64 295.96C1414.7 307.988 1388.58 302.824 1374.92 298.657Z",
    fill: "#492E0D"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.92 298.657C1363.98 295.323 1372.32 269.504 1377.85 257.012L1406.89 258.05C1408.12 266.677 1410.99 286.337 1412.64 295.96C1414.7 307.988 1388.58 302.824 1374.92 298.657Z",
    fill: "#492E0D"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.92 298.657C1363.98 295.323 1372.32 269.504 1377.85 257.012L1406.89 258.05C1408.12 266.677 1410.99 286.337 1412.64 295.96C1414.7 307.988 1388.58 302.824 1374.92 298.657Z",
    fill: "#492E0D"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.26 332.581C1362.85 329.102 1371.55 302.161 1377.32 289.126L1407.62 290.209C1408.91 299.211 1411.9 319.726 1413.62 329.767C1415.77 342.318 1388.52 336.929 1374.26 332.581Z",
    fill: "#492E0D"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.26 332.581C1362.85 329.102 1371.55 302.161 1377.32 289.126L1407.62 290.209C1408.91 299.211 1411.9 319.726 1413.62 329.767C1415.77 342.318 1388.52 336.929 1374.26 332.581Z",
    fill: "#492E0D"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.26 332.581C1362.85 329.102 1371.55 302.161 1377.32 289.126L1407.62 290.209C1408.91 299.211 1411.9 319.726 1413.62 329.767C1415.77 342.318 1388.52 336.929 1374.26 332.581Z",
    fill: "#492E0D"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.26 332.581C1362.85 329.102 1371.55 302.161 1377.32 289.126L1407.62 290.209C1408.91 299.211 1411.9 319.726 1413.62 329.767C1415.77 342.318 1388.52 336.929 1374.26 332.581Z",
    fill: "#492E0D"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1372.07 371.45C1359.99 367.768 1369.2 339.252 1375.31 325.454L1407.38 326.601C1408.74 336.129 1411.91 357.843 1413.73 368.471C1416.01 381.756 1387.16 376.052 1372.07 371.45Z",
    fill: "#492E0D"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1372.07 371.45C1359.99 367.768 1369.2 339.252 1375.31 325.454L1407.38 326.601C1408.74 336.129 1411.91 357.843 1413.73 368.471C1416.01 381.756 1387.16 376.052 1372.07 371.45Z",
    fill: "#492E0D"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M1372.07 371.45C1359.99 367.768 1369.2 339.252 1375.31 325.454L1407.38 326.601C1408.74 336.129 1411.91 357.843 1413.73 368.471C1416.01 381.756 1387.16 376.052 1372.07 371.45Z",
    fill: "#492E0D"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1372.07 371.45C1359.99 367.768 1369.2 339.252 1375.31 325.454L1407.38 326.601C1408.74 336.129 1411.91 357.843 1413.73 368.471C1416.01 381.756 1387.16 376.052 1372.07 371.45Z",
    fill: "#492E0D"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1373.06 413.03C1359.09 410.352 1365.98 377.289 1371.17 361.092L1407.26 358.528C1409.92 369.043 1416.08 392.998 1419.4 404.691C1423.54 419.307 1390.53 416.377 1373.06 413.03Z",
    fill: "#492E0D"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M1373.06 413.03C1359.09 410.352 1365.98 377.289 1371.17 361.092L1407.26 358.528C1409.92 369.043 1416.08 392.998 1419.4 404.691C1423.54 419.307 1390.53 416.377 1373.06 413.03Z",
    fill: "#492E0D"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1373.06 413.03C1359.09 410.352 1365.98 377.289 1371.17 361.092L1407.26 358.528C1409.92 369.043 1416.08 392.998 1419.4 404.691C1423.54 419.307 1390.53 416.377 1373.06 413.03Z",
    fill: "#492E0D"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M1373.06 413.03C1359.09 410.352 1365.98 377.289 1371.17 361.092L1407.26 358.528C1409.92 369.043 1416.08 392.998 1419.4 404.691C1423.54 419.307 1390.53 416.377 1373.06 413.03Z",
    fill: "#492E0D"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.89 150.208C1349.13 150.208 1358.34 134.451 1362.79 126.573C1385.23 121.778 1413.66 101.808 1347.89 60.2922C1282.13 18.7767 1223.89 60.1209 1203 85.9825C1223.14 67.0744 1259 66.1153 1274.42 67.9993C1274.01 68.8214 1273.91 70.397 1273.91 71.0821C1294.87 68.2048 1305.59 72.966 1308.33 75.7063C1311.62 82.283 1308.33 83.9272 1306.27 83.9272C1288.6 83.1051 1268.42 95.916 1260.55 102.424C1261.78 102.013 1262.77 103.281 1263.12 103.966C1236.81 122.052 1226.12 142.33 1224.07 150.208H1226.63C1218.83 170.76 1223.38 185.832 1226.63 190.799C1227.87 175.179 1240.85 157.23 1247.19 150.208C1246.37 151.852 1247.53 155.346 1248.21 156.888C1248.21 153.599 1269.79 133.938 1280.58 124.518C1279.76 127.395 1280.24 130.512 1280.58 131.711C1305.25 113.214 1315.52 110.988 1317.58 112.186C1316.35 112.598 1315.35 116.126 1315.01 117.838C1317.89 117.427 1318.95 119.037 1319.12 119.894C1301.03 132.636 1295.14 162.197 1294.46 175.385H1296.51C1292.81 209.09 1306.62 236.014 1313.98 245.262C1307.41 221.422 1309.87 199.02 1311.93 190.799C1313.98 190.388 1315.87 195.08 1316.55 197.478C1316.14 186.791 1324.94 168.02 1329.4 159.97C1329.05 163.053 1328.88 169.116 1330.94 168.705C1332.99 168.294 1342.07 149.352 1346.35 139.932C1346.35 143.357 1346.66 150.208 1347.89 150.208Z",
    fill: "#214325"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M1395.7 136.972C1394.54 137.169 1360.96 115.797 1355.62 109.766C1333.73 109.237 1303.98 96.6805 1360.14 50.6882C1416.29 4.69589 1477.27 30.7923 1500.74 49.5895C1478.99 36.6212 1444.96 41.5127 1430.67 45.5795C1431.18 46.2173 1431.5 47.549 1431.6 48.1351C1411.38 49.0123 1401.93 54.7933 1399.74 57.5741C1397.58 63.7244 1400.93 64.6073 1402.87 64.2799C1419.45 60.7615 1440.36 68.5082 1448.74 72.8213C1447.52 72.666 1446.76 73.9085 1446.54 74.5492C1474 85.8322 1487.02 101.479 1490.1 107.891L1487.67 108.3C1498.02 124.64 1495.89 138.259 1493.53 143.027C1490.11 129.86 1475.25 116.572 1468.25 111.574C1469.27 112.85 1468.67 116.024 1468.25 117.452C1467.77 114.639 1444.55 101.255 1432.99 94.9144C1434.19 97.2451 1434.18 99.9883 1434.03 101.068C1408.06 89.1719 1420.63 98.2628 1418.86 99.6158C1420.09 99.7711 1421.53 102.631 1422.1 104.042C1419.33 104.149 1418.56 105.695 1418.52 106.455C1437.44 114.476 1447.27 138.827 1449.82 150.001L1447.88 150.328C1456.24 178.575 1447.08 203.807 1441.45 212.892C1444.23 191.449 1438.67 172.676 1435.54 165.97C1433.54 165.946 1432.43 170.261 1432.13 172.421C1430.98 163.213 1419.96 148.556 1414.59 142.378C1415.36 144.961 1416.39 150.121 1414.39 150.097C1412.39 150.072 1401.08 135.312 1395.68 127.935C1396.17 130.866 1396.87 136.776 1395.7 136.972Z",
    fill: "#214325"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6_194",
    x: 577.992,
    y: -6.04642,
    width: 679.91,
    height: 467.082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "effect1_foregroundBlur_6_194"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6_194",
    x: 577.992,
    y: -6.04642,
    width: 679.91,
    height: 467.082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "effect1_foregroundBlur_6_194"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_6_194",
    x: 30.5616,
    y: 52.4289,
    width: 734.844,
    height: 427.448,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.5,
    result: "effect1_foregroundBlur_6_194"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_6_194",
    x: 30.5618,
    y: 52.4289,
    width: 734.844,
    height: 427.448,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.5,
    result: "effect1_foregroundBlur_6_194"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_194",
    x1: 1025.88,
    y1: 280.334,
    x2: 1492.85,
    y2: 452.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FCF8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_194",
    x1: 1077.44,
    y1: 239.272,
    x2: 929.451,
    y2: 299.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE964B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C57E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_194",
    x1: 1025.88,
    y1: 280.334,
    x2: 1492.85,
    y2: 452.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FCF8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_194",
    x1: 1077.44,
    y1: 239.272,
    x2: 929.451,
    y2: 299.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE964B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C57E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_194",
    x1: 669.697,
    y1: 213.328,
    x2: 1333.55,
    y2: 495.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FCF8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_194",
    x1: 669.697,
    y1: 213.328,
    x2: 1333.55,
    y2: 495.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FCF8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_194",
    x1: 714.679,
    y1: 152.561,
    x2: 510.048,
    y2: 235.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE964B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C57E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6_194",
    x1: 714.679,
    y1: 152.561,
    x2: 510.048,
    y2: 235.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE964B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C57E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6_194",
    x1: 244.858,
    y1: 226.492,
    x2: 734.574,
    y2: 442.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFDABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF3ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6_194",
    x1: 293.02,
    y1: 235.681,
    x2: 88.3896,
    y2: 318.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE964B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C57E42"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSceneryLight);
export default __webpack_public_path__ + "static/media/SceneryLight.9f718255f33ca7d2080231f09e42d128.svg";
export { ForwardRef as ReactComponent };